import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as ChevronDown } from '../../../../icons/chevron-down.svg';
import { ReactComponent as DateIcon } from '../../../../icons/calendar-icon.svg';
import ImmutableFormComponent from './ImmutableForm';
import clsx from 'clsx';
import { format } from 'date-fns';
import { addDays } from 'date-fns';
import MutableFormComponent from './mutableForm';
import PreviewImage from 'components/Modals/PreviewImage';
import { setCurrency } from 'utils/functionality';

const AreaListForm = ({
  item,
  index,
  areaCharterData,
  allAreaCharter,
  setAllAreaCharter,
  forCustomOrder,
  startDate,
  rentalLocation,
  locationData,
  boundingBoxLocation,
  disable,
  sameLocationCheck,
}) => {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const clickHeaderHandler = () => {
    setAccordionOpen((prevState) => !prevState);
  };

  const imagePreviewHandler = (image) => {
    setShowImage(true);
    setSelectedImage(image);
  };

  return (
    <>
      <li className="area-list-form">
        <div className="header" onClick={clickHeaderHandler}>
          <div className="header__date">
            <div>
              <DateIcon />
              <span>Day-{item}</span>
            </div>
            <div>
              <span />
              <p>{startDate && !isNaN(startDate) && format(addDays(startDate, index), 'dd MMMM yyyy')}</p>
            </div>
            {!forCustomOrder && (
              <div>
                <span />
                <p>{`(${setCurrency(areaCharterData?.total_price, 'IDR')})`}</p>
              </div>
            )}
          </div>
          <ChevronDown className={clsx(`chevron`, accordionOpen ? 'up' : 'down')} />
        </div>

        <div className={clsx('body', accordionOpen ? 'open' : 'close')}>
          {forCustomOrder ? (
            <MutableFormComponent
              item={item}
              index={index}
              areaCharterData={areaCharterData}
              allAreaCharter={allAreaCharter}
              setAllAreaCharter={setAllAreaCharter}
              rentalLocation={rentalLocation}
              locationData={locationData}
              boundingBoxLocation={boundingBoxLocation}
              disable={disable}
              sameLocationCheck={sameLocationCheck}
              startDate={startDate}
            />
          ) : (
            <ImmutableFormComponent
              item={item}
              areaCharterData={areaCharterData}
              imagePreviewHandler={imagePreviewHandler}
            />
          )}
        </div>
      </li>
      {showImage &&
        ReactDOM.createPortal(
          <PreviewImage image={selectedImage} setShow={() => setShowImage(false)} />,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default AreaListForm;
